export function getGaFolderType(folder?: { kind?: string; parent?: string }): string {
    return folder?.kind === 'family' ? 'family_folder' : folder?.parent !== '/' ? 'folder_in_folder' : 'folder';
}
